/*
 * PDP bundle box v2 (sections/product-bundles.liquid), 2026-10-14.
 *
 * One card: this product + its accessories as ticked rows. Any combination can be ticked;
 * the themed segments (protect / charge / travel) are presets that set the ticks, built
 * from the row kinds the section classified (data-pbx-kind). Only buildable presets show;
 * the cheapest is ticked on load. Live total, one add-to-cart for the ticked items.
 *
 * CART: same lines the old section sent. One line per ticked item, quantity 1, with
 *   _bookerz-domain       = request.host (server rendered, data-domain)
 *   _bookerz-checkout-url = location.href
 * The drawer is opened with the Impact ProductForm contract (assets/theme.js.liquid,
 * ProductForm._onSubmit): prepare-bundled-sections -> add.js with sections ->
 * cart.js with sections grafted -> variant:add (opens) -> cart:change (repaints).
 *
 * No analytics here on purpose.
 */
(function () {
  'use strict';

  function moneyFormatter(sample) {
    if (window.swbMoney) return window.swbMoney; /* the Price settings per market (layout/theme.liquid) */
    /* sample is {{ 123456 | money }} in the market's own currency, e.g. "€1.234,56" or "£1,234.56" */
    var s = String(sample || '').trim();
    var i1 = s.indexOf('1'), i234 = s.indexOf('234'), i56 = s.lastIndexOf('56');
    if (i1 < 0 || i234 < 0 || i56 < 0) {
      return function (c) { return (c / 100).toFixed(2); };
    }
    var pre = s.slice(0, i1), thou = s.slice(i1 + 1, i234), dec = s.slice(i234 + 3, i56), post = s.slice(i56 + 2);
    return function (cents) {
      var neg = cents < 0; cents = Math.abs(Math.round(cents));
      var whole = String(Math.floor(cents / 100)), frac = ('0' + (cents % 100)).slice(-2);
      whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return (neg ? '-' : '') + pre + whole + (dec ? dec + frac : '') + post;
    };
  }

  function variantOf(row) {
    var el = row.querySelector('[data-pbx-variant]');
    if (!el) return null;
    var src = el.tagName === 'SELECT' ? el.options[el.selectedIndex]
      : (el.tagName === 'INPUT' ? el : el.querySelector('input:checked') || el.querySelector('input:not([disabled])'));
    if (!src) return null;
    return {
      id: parseInt(src.value, 10),
      price: parseInt(src.getAttribute('data-price'), 10) || 0,
      compare: parseInt(src.getAttribute('data-compare'), 10) || 0,
      available: src.getAttribute('data-available') === 'true'
    };
  }

  function init(root) {
    if (root.dataset.pbxInit === '1') return;
    root.dataset.pbxInit = '1';

    var fmt = moneyFormatter(root.getAttribute('data-money-sample'));
    var T = {
      add: root.getAttribute('data-t-add'), adding: root.getAttribute('data-t-adding'),
      added: root.getAttribute('data-t-added'), error: root.getAttribute('data-t-error'),
      none: root.getAttribute('data-t-none')
    };
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-item]'));
    var mainRow = root.querySelector('[data-pbx-item="main"]');
    var extras = rows.filter(function (r) { return r !== mainRow; });
    var toolRequired = root.getAttribute('data-tool-required') === 'true';
    var seg = root.querySelector('[data-pbx-seg]'), hint = root.querySelector('[data-pbx-hint]');
    var presets = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-preset]'));
    var moreBtn = root.querySelector('[data-pbx-more]');
    var visibleMax = parseInt(root.getAttribute('data-visible-max'), 10) || 4;
    var expanded = false;
    T.more = root.getAttribute('data-t-more'); T.less = root.getAttribute('data-t-less');
    var addBtn = root.querySelector('[data-pbx-add]');
    var elTotal = root.querySelector('[data-pbx-total]'), elOld = root.querySelector('[data-pbx-old]');
    var elSave = root.querySelector('[data-pbx-save]'), elSaveAmt = root.querySelector('[data-pbx-save-amt]');
    var mainVar = root.querySelector('[data-pbx-main-var] [data-pbx-variant]');
    var busy = false, resetTimer = null;
    var mainSoldOut = addBtn && addBtn.disabled && !(variantOf(mainRow) || {}).available;

    function liveRows() { return rows; }
    function canTick(row) {
      var cb = row.querySelector('[data-pbx-check]'), v = variantOf(row);
      return !!(cb && !cb.disabled && v && v.available);
    }
    /* the cheapest tickable accessory of a kind: presets should feel like a deal,
       not like the most expensive charger in the list */
    function firstOf(kind) {
      var pool = extras.filter(function (r) { return r.getAttribute('data-pbx-kind') === kind && canTick(r); });
      pool.sort(function (x, y) { return (variantOf(x).price || 0) - (variantOf(y).price || 0); });
      return pool[0] || null;
    }
    /* The themed items of a preset, or null when it cannot be built here.
       protect: case + screen protector (either alone counts)
       charge:  the cheapest charger; without one a cable or powerbank
       travel:  pouch + powerbank (or charger); without a pouch a powerbank alone */
    function presetItems(key) {
      var a = [];
      if (key === 'protect') a = [firstOf('case'), firstOf('screen')];
      else if (key === 'charge') {
        a = [firstOf('charger') || firstOf('cable') || firstOf('powerbank')];
      } else if (key === 'travel') {
        var pouch = firstOf('pouch'), pb = firstOf('powerbank');
        a = pouch ? [pouch, pb || firstOf('charger')] : [pb];
      }
      a = a.filter(Boolean);
      return a.length ? a : null;
    }
    /* this product + (the toolkit, when the strap needs one to be shortened) + the items */
    function presetSet(key) {
      var items = presetItems(key);
      if (!items) return null;
      var tool = toolRequired ? firstOf('tool') : null;
      return [mainRow].filter(canTick).concat(tool ? [tool] : [], items);
    }
    function sameSet(a, b) { return a.length === b.length && a.every(function (r) { return b.indexOf(r) > -1; }); }
    function applyPreset(key) {
      var set = presetSet(key);
      if (!set) return;
      rows.forEach(function (r) {
        var cb = r.querySelector('[data-pbx-check]');
        if (cb && !cb.disabled) cb.checked = set.indexOf(r) > -1;
      });
      /* a preset that ticks a collapsed accessory opens the list so it is seen */
      if (set.some(function (r) { var i = extras.indexOf(r); return i >= visibleMax; })) expanded = true;
      paint();
    }
    function sumOf(set) {
      return set.reduce(function (a, r) { var v = variantOf(r); return a + (v ? v.price : 0); }, 0);
    }
    /* Collapsed shows the first visibleMax accessories, full stop. It used to keep
       every TICKED row visible too, so after "Compleet" (everything ticked) the
       "Minder tonen" button changed nothing: the bug Alejandro hit on 2026-10-14.
       A ticked row that is collapsed away still counts, and the button says how many. */
    function layoutExtras() {
      var hiddenTicked = 0;
      extras.forEach(function (r, i) {
        r.hidden = !expanded && i >= visibleMax;
        if (r.hidden && isIncluded(r)) hiddenTicked++;
      });
      if (moreBtn) {
        moreBtn.textContent = expanded ? T.less : (T.more + (hiddenTicked ? ' (' + hiddenTicked + ' \u2713)' : ''));
        moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        moreBtn.hidden = extras.length <= visibleMax;
      }
    }
    function isIncluded(row) {
      var cb = row.querySelector('[data-pbx-check]');
      var v = variantOf(row);
      return !!(cb && cb.checked && !cb.disabled && v && v.available);
    }

    function paintRow(row) {
      var out = row.querySelector('[data-pbx-price]'), v = variantOf(row);
      if (!out || !v) return;
      if (!canTick(row)) { row.classList.add('is-off'); return; }
      var html = '';
      if (v.compare > v.price) html += '<s class="pbx__was">' + fmt(v.compare) + '</s>';
      html += '<span class="pbx__now">' + fmt(v.price) + '</span>';
      out.innerHTML = html;
      row.classList.toggle('is-off', !isIncluded(row));
    }

    function paint() {
      var total = 0, was = 0, n = 0;
      liveRows().forEach(function (row) {
        paintRow(row);
        if (!isIncluded(row)) return;
        var v = variantOf(row);
        total += v.price; was += Math.max(v.compare, v.price); n++;
      });
      if (elTotal) elTotal.textContent = fmt(total);
      if (elOld) { elOld.textContent = was > total ? fmt(was) : ''; elOld.hidden = !(was > total); }
      if (elSave) {
        var save = was - total;
        elSave.hidden = !(save > 0);
        if (save > 0 && elSaveAmt) elSaveAmt.textContent = fmt(save) + ' (' + Math.round(save / was * 100) + '%)';
      }
      presets.forEach(function (b) {
        var set = presetSet(b.getAttribute('data-pbx-preset'));
        if (!set || b.hidden) return;
        var pr = b.querySelector('[data-pbx-preset-price]');
        if (pr) pr.textContent = fmt(sumOf(set));
        var same = rows.every(function (r) { return (set.indexOf(r) > -1) === isIncluded(r); });
        b.setAttribute('aria-pressed', same ? 'true' : 'false');
      });
      layoutExtras();
      if (addBtn && !busy) {
        if (mainSoldOut && n === 0) { addBtn.disabled = true; return; }
        addBtn.disabled = n === 0;
        addBtn.textContent = n === 0 ? T.none : T.add;
      }
    }

    presets.forEach(function (b) {
      b.addEventListener('click', function () { applyPreset(b.getAttribute('data-pbx-preset')); });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () { expanded = !expanded; layoutExtras(); });

    /* Which presets can be built here: show those (max 3, never two identical ones),
       then tick the cheapest and move its items up under this product so the
       default bundle is visible without opening the list. */
    function setupPresets() {
      var shown = [];
      presets.forEach(function (b) {
        var set = presetSet(b.getAttribute('data-pbx-preset'));
        var dupe = set && shown.some(function (o) { return sameSet(o.set, set); });
        b.hidden = !set || dupe || shown.length >= 3;
        if (!b.hidden) shown.push({ b: b, set: set });
      });
      if (seg) seg.hidden = !shown.length;
      if (hint) hint.hidden = !shown.length;
      if (!shown.length) return;
      var best = shown.slice().sort(function (x, y) { return sumOf(x.set) - sumOf(y.set); })[0];
      var list = mainRow.parentNode, after = mainRow;
      best.set.forEach(function (r) {
        if (r === mainRow) return;
        if (after.nextSibling !== r) list.insertBefore(r, after.nextSibling);
        after = r;
      });
      rows = Array.prototype.slice.call(root.querySelectorAll('[data-pbx-item]'));
      extras = rows.filter(function (r) { return r !== mainRow; });
      applyPreset(best.b.getAttribute('data-pbx-preset'));
      /* the preset most people take, marked (2026-10-16, asked) */
      var popT = root.getAttribute('data-t-pop');
      if (popT && !best.b.querySelector('.pbx__seg-pop')) { var pp = document.createElement('span'); pp.className = 'pbx__seg-pop'; pp.textContent = popT; best.b.appendChild(pp); }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-pbx-check], [data-pbx-variant]')) paint();
      if (mainVar && mainVar.contains(e.target) || e.target === mainVar) syncBuildLinks();
    });

    /* the builder link carries the strap + the size chosen here */
    function syncBuildLinks() {
      var v = variantOf(mainRow); if (!v) return;
      var links = root.querySelectorAll('[data-pbx-build]');
      Array.prototype.forEach.call(links, function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.href);
          u.searchParams.set('variant', String(v.id));
          a.setAttribute('href', u.pathname + u.search);
        } catch (err) {}
      });
    }

    /* follow the size picked in the main product form above (Impact fires variant:change
       on the form without bubbling, so listen in the capture phase) */
    if (mainVar && mainVar.tagName !== 'INPUT') {
      document.addEventListener('variant:change', function (e) {
        var v = e && e.detail && e.detail.variant;
        if (!v || !v.id) return;
        if (mainVar.tagName === 'SELECT') {
          if (!mainVar.querySelector('option[value="' + v.id + '"]') || mainVar.value === String(v.id)) return;
          mainVar.value = String(v.id);
        } else {
          var radio = mainVar.querySelector('input[value="' + v.id + '"]');
          if (!radio || radio.checked || radio.disabled) return;
          radio.checked = true;
        }
        paint(); syncBuildLinks();
      }, true);
    }

    /* ── add to cart ─────────────────────────────────────────────────────── */
    function setBtn(text, ms) {
      if (!addBtn) return;
      addBtn.textContent = text;
      clearTimeout(resetTimer);
      if (ms) resetTimer = setTimeout(function () { busy = false; addBtn.removeAttribute('aria-busy'); paint(); }, ms);
    }

    if (addBtn) addBtn.addEventListener('click', function () {
      if (busy) return;
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var domain = root.getAttribute('data-domain') || window.location.host;
      var items = liveRows().filter(isIncluded).map(function (row) {
        return {
          id: variantOf(row).id,
          quantity: 1,
          properties: { '_bookerz-domain': domain, '_bookerz-checkout-url': window.location.href }
        };
      });
      if (!items.length) return;
      busy = true;
      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      setBtn(T.adding);

      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: rootUrl + 'variants/' + items[0].id })
      })
        .then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw j; return j; });
        })
        .then(function (added) {
          var th = window.themeVariables && window.themeVariables.settings;
          if (th && (th.cartType === 'page' || th.pageType === 'cart')) {
            window.location.href = rootUrl + 'cart';
            return;
          }
          /* SPEED (2026-10-27): the theme only reads item_count and sections from this cart, and the freshly rendered
             drawer already prints the count, so the second round trip to cart.js is skipped. It stays as the fallback. */
          var quick = quickCart(added.sections);
          return (quick ? Promise.resolve(quick) : fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); }))
            .then(function (cart) {
              cart.sections = added.sections;
              document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
                bubbles: true,
                detail: { items: added.items || [added], cart: cart }
              }));
              document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                bubbles: true,
                detail: { baseEvent: 'variant:add', cart: cart }
              }));
              addBtn.disabled = false;
              setBtn(T.added, 2200);
            });
        })
        .catch(function (err) {
          try { console.warn('[pbx] add failed', err); } catch (e) {}
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          addBtn.disabled = false;
          setBtn((err && err.description) || T.error, 3000);
        });
    });

    function quickCart(secs) {
      if (!secs) return null;
      for (var k in secs) {
        var m = k !== 'variant-added' && typeof secs[k] === 'string' && /<cart-count[^>]*>\s*(\d+)\s*</.exec(secs[k]);
        if (m) return { item_count: +m[1] };
      }
      return null;
    }

    /* back/forward cache: never come back to a frozen "Bezig met toevoegen" */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      busy = false; clearTimeout(resetTimer);
      if (addBtn) addBtn.removeAttribute('aria-busy');
      paint();
    });

    /* ── info sheet ──────────────────────────────────────────────────────── */
    var sheet = root.querySelector('[data-pbx-sheet]');
    var infoBtn = root.querySelector('[data-pbx-info]');
    var lastFocus = null;
    function onKey(e) { if (e.key === 'Escape') closeSheet(); }
    function openSheet() {
      if (!sheet) return;
      lastFocus = document.activeElement;
      /* out of the section: an ancestor transform/overflow would trap position:fixed */
      if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
      sheet.hidden = false;
      void sheet.offsetWidth;
      sheet.classList.add('is-open');
      document.documentElement.classList.add('pbx-lock');
      document.addEventListener('keydown', onKey);
      var x = sheet.querySelector('.pbx-sheet__x');
      if (x) x.focus({ preventScroll: true });
    }
    function closeSheet() {
      if (!sheet || sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.documentElement.classList.remove('pbx-lock');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { sheet.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    /* the info of ONE preset (2026-10-15, asked): what is in it, each with its photo and price, and the total;
       the head's own (i) keeps the general explanation */
    var dyn = sheet && sheet.querySelector('[data-pbx-sheet-dyn]');
    var genList = sheet && sheet.querySelector('.pbx-sheet__list');
    var sheetTitle = sheet && sheet.querySelector('.pbx-sheet__title');
    var tInfo = root.getAttribute('data-t-info'), tIn = root.getAttribute('data-t-in');
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function openPresetInfo(key) {
      var set = presetSet(key);
      if (!set || !dyn) return;
      var btn = root.querySelector('[data-pbx-preset="' + key + '"]');
      var nameEl = btn && btn.querySelector('.pbx__seg-name');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var html = '<p class="pbx-sheet__sub">' + esc(root.getAttribute('data-t-d-' + key) || '') + '</p>' +
        '<p class="pbx-sheet__h">' + esc(tIn || '') + '</p><ul class="pbx-sheet__items" role="list">';
      set.forEach(function (r) {
        var img = r.querySelector('.pbx__img img'), nm = r.querySelector('.pbx__name'), v = variantOf(r);
        html += '<li>' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" width="48" height="48" loading="lazy">' : '<i></i>') +
          '<b>' + esc(nm ? nm.textContent.trim() : '') + '</b><span>' + esc(v ? fmt(v.price) : '') + '</span></li>';
      });
      html += '</ul><p class="pbx-sheet__total"><span>' + esc(name) + '</span><span>' + esc(fmt(sumOf(set))) + '</span></p>';
      dyn.innerHTML = html;
      dyn.hidden = false;
      if (genList) genList.hidden = true;
      if (sheetTitle) sheetTitle.textContent = name;
      openSheet();
    }
    function openGeneralInfo() {
      if (dyn) { dyn.hidden = true; dyn.innerHTML = ''; }
      if (genList) genList.hidden = false;
      if (sheetTitle && tInfo) sheetTitle.textContent = tInfo;
      openSheet();
    }
    /* the info of ONE product in the list (2026-10-15, asked: on each product, not on the presets): photo, price,
       description and a link to its page; opens at once with what the row knows, the description follows */
    var itemCache = {};
    function paintItem(p, row, url, first) {
      var im = p && p.images && p.images[0] ? (typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src) : (row && row.querySelector('.pbx__img img') ? (row.querySelector('.pbx__img img').currentSrc || row.querySelector('.pbx__img img').src) : '');
      if (im) im = im.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '').replace(/([?&])&+/g, '$1') + (im.indexOf('?') > -1 ? '&' : '?') + 'width=480';
      var txt = p && p.body_html ? String(p.body_html).replace(/<style[\s\S]*?<\/style>|<script[\s\S]*?<\/script>/gi, '').replace(/<[^>]+>/g, ' ').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/\s+/g, ' ').trim() : '';
      if (txt.length > 420) txt = txt.slice(0, 420).replace(/\s\S*$/, '') + '\u2026';
      var priceHtml = row && row.querySelector('[data-pbx-price]') ? row.querySelector('[data-pbx-price]').innerHTML : '';
      var title = (p && p.title) || (row && row.querySelector('.pbx__name') ? row.querySelector('.pbx__name').textContent.trim() : '');
      dyn.innerHTML = (im ? '<img class="pbx-sheet__hero" src="' + esc(im) + '" alt="" loading="lazy">' : '') +
        '<p class="pbx-sheet__pprice">' + priceHtml + '</p>' + (txt ? '<p class="pbx-sheet__sub">' + esc(txt) + '</p>' : '') +
        (url ? '<a class="pbx-sheet__view" href="' + esc(url) + '">' + esc(root.getAttribute('data-t-view') || 'View product') + '</a>' : '');
      dyn.hidden = false;
      if (genList) genList.hidden = true;
      if (sheetTitle) sheetTitle.textContent = title;
      if (first) openSheet();
    }
    function openItemInfo(btn) {
      var h = btn.getAttribute('data-pbx-item-info'), url = btn.getAttribute('data-url') || '';
      if (!h || !dyn) return;
      var row = btn.closest('[data-pbx-item]');
      /* the shared sheet, with the product's pros and cons (2026-10-15, asked) */
      if (window.swbV2InfoSheet) {
        var rim = row && row.querySelector('.pbx__img img'), rnm = row && row.querySelector('.pbx__name'), rpr = row && row.querySelector('[data-pbx-price]');
        window.swbV2InfoSheet.open({ handle: h, url: url, title: rnm ? rnm.textContent.trim() : '', img: rim ? (rim.currentSrc || rim.src) : '', priceHtml: rpr ? rpr.innerHTML : '' });
        return;
      }
      if (itemCache[h]) { paintItem(itemCache[h], row, url, true); return; }
      paintItem(null, row, url, true);
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) { itemCache[h] = p; if (sheet && !sheet.hidden) paintItem(p, row, url, false); } })
        .catch(function () {});
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-pbx-item-info]'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openItemInfo(b); });
    });
    if (infoBtn) infoBtn.addEventListener('click', openGeneralInfo);
    if (sheet) sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-pbx-close]')) closeSheet();
    });

    setupPresets();
    paint();
    syncBuildLinks();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-pbx]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* theme editor re-renders the section */
  document.addEventListener('shopify:section:load', boot);
})();
